import { musicStartYState, musicURLState, muteState, playState, globalBgmPausedState, routeBgmMutedState } from '@atom/setting/jukebox';
import ReactPlayer from '@components/library/react-player'
import React, { useEffect, useRef, useState } from 'react'
import { useRecoilState, useRecoilValue } from 'recoil';
import { extractPlaylistId } from '../utils/musicPlayerUtils';
import styled from 'styled-components';
import useScrollY from '@hooks/useScrollY';
import { jukeboxActiveState } from '@atom/setting/navigation';
import { Ijukebox } from '@typings/setting/jukebox.interface';

const EmptyPage = styled.div`
  color: var(--subTextColor);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 340px;
  height: 200px;
  font-size: 13px;
`;

function MultiPlayer({ jukebox, index }: { jukebox?: Ijukebox, index: number }) {
  const [onPlay, setPlay] = useRecoilState(playState);
  const [playerReady, setPlayerReady] = useState(false);
  const [muted, setMuted] = useRecoilState(muteState);
  const [volume, setVolume] = useState(0.5);
  const [musicURL, setMusicURL] = useRecoilState(musicURLState);
  const startY = useRecoilValue(musicStartYState);
  const scrollY = useScrollY();
  const hasStartedRef = useRef(false);
  const [jukeboxActive, setJukeboxActive] = useRecoilState(jukeboxActiveState);
  
  // 🎵 페이지 BGM에 의해 전역 BGM이 일시정지된 상태
  const isGlobalBgmPaused = useRecoilValue(globalBgmPausedState);
  // 🎵 라우트 레벨 음소거 (특정 페이지에서 완전 차단)
  const isRouteBgmMuted = useRecoilValue(routeBgmMutedState);

  useEffect(() => {
    if (!jukebox) return;
    setJukeboxActive(jukebox.isActive);
    setVolume(jukebox.defaultVolume || 0.5);

    // 외부(useSetTheme 등)에서 이미 musicURL이 설정된 경우 덮어쓰지 않음
    // musicURL이 비어있는 경우에만 jukebox URL 설정
    setMusicURL((prev) => prev || jukebox.youtubeURL || '');

    if (jukebox.isActive && !startY) {
      // 홈페이지에서만 즉시 실행
      setPlay(true);
      document.addEventListener('click', () => setMuted(false), { once: true });
    }
  }, [jukebox, startY]);


  useEffect(() => {
    if (!startY || !musicURL) return;

    const _startY = Number(startY);
    const hasScrolledPastTrigger = scrollY >= _startY;

    if (hasScrolledPastTrigger && !hasStartedRef.current) {
      setPlay(true);
      document.addEventListener('click', () => setMuted(false), { once: true });
      hasStartedRef.current = true;
    }

    // 재생 조건이 아직 안 되었을 경우엔 음악을 꺼둠
    if (!hasScrolledPastTrigger && !hasStartedRef.current) {
      setPlay(false);
    }
  }, [startY, scrollY, jukebox, musicURL]);

  if (!musicURL) return <EmptyPage>
    <p>
      설정된 음악이 없습니다. <br />
    </p>
  </EmptyPage>;

  // 🎵 페이지 BGM이 재생 중이거나 라우트 레벨 음소거이면 재생 안 함
  const shouldPlay = onPlay && !isGlobalBgmPaused && !isRouteBgmMuted;

  return (
    <>  <ReactPlayer
      key={musicURL || 'empty'} // key를 업데이트하여 강제로 컴포넌트를 재생성
      url={musicURL}
      width={'100%'}
      height={'240px'}
      playing={shouldPlay}
      loop
      muted={muted}
      controls
      onReady={() => setPlayerReady(true)}
      volume={playerReady && shouldPlay ? volume : 0}
      config={{
        youtube: {
          playerVars: {
            loop: 1,
            autoplay: shouldPlay ? 1 : 0,
            authuser: 0,
            ...(extractPlaylistId(musicURL)
              ? {
                listType: 'playlist',
                playlist: extractPlaylistId(musicURL),
              }
              : {}),
            rel: 0,
            showinfo: 1,
          },
        },
      }}
    />

    </>
  )
}

export default MultiPlayer